var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 595,
    viewBox: "0 0 1280 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_5999)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 595,
    fill: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.076 187.914C726.576 203.914 486.076 162.914 412.576 164.414C339.076 165.914 343.576 165.914 297.076 169.914C250.576 173.914 201.601 179.755 156.076 190.66C104.428 202.535 54.5761 224.914 -6.92386 251.914C-68.4238 278.914 0 595 0 595H1280C1280 595 1418 -44.5001 1279 14.4999C1140 73.4999 1029.68 169.881 869.076 187.914Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_184_5999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7 280.5C120.322 216.145 208.04 197.342 361.5 188.276C518.5 179 663.308 228.057 817 239C971.5 250 1102.93 210.894 1282 125M-7 290.5C120.322 226.145 208.04 207.342 361.5 198.276C518.5 189 666.635 252.158 820 267C959.5 280.5 1107.43 268.894 1286.5 183M-7 300.499C120.322 236.144 208.04 217.341 361.5 208.275C518.5 198.999 658.859 270.042 810 299.999C921 322 1107.93 329.393 1287 243.499M-7 310.498C120.322 246.143 208.04 227.341 361.5 218.274C518.5 208.998 636.259 295.256 784 339C873.5 365.5 1100 388 1284 309.998M-7 270.5C120.322 206.145 208.04 187.342 361.5 178.276C518.5 169 662.919 211.5 817 211.5C1037 211.5 1103.43 146.894 1282.5 61",
    stroke: "#89A5C1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_5999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 595,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_184_5999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 303,
    fill: "white",
    transform: "translate(0 61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSvg);
export default __webpack_public_path__ + "static/media/footerSVG.5a6596b3e660756361048954ae04c52b.svg";
export { ForwardRef as ReactComponent };